import React, { useEffect, useState } from "react";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  Divider,
  FormControl,
  Grid2,
  TextField,
  Typography,
  Button as MatButton,
  Menu,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableSortLabel,
  TableCell,
  TableBody,
  TablePagination,
  Tooltip,
  Link,
  IconButton,
} from "@mui/material";
import {
  STATUS_CUSTOM_OTHERS,
  SCHEDULE_STATUS,
} from "../../../../utils/static-masters";
import ExportIcon from "../../../../assets/images/icons/export.svg";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import DataNotFound from "../../../../shared/DataNotFound/DataNotFound";
import ViewTableWrapper from "../../../../shared/ViewTableWrapper/ViewTableWrapper";
import { useLocation, useNavigate } from "react-router-dom";
import SlotStatus from "../../../../shared/SlotStatus/SlotStatus";
import SuccessDialog from "../../../../web/ExplorePositions/SucessfulDialog";
import { getUser } from "../../../../utils/types";
import API from "../../../../api/axios";
import moment from "moment";
import DataLoader from "../../../../shared/DataLoader/DataLoader";
import { ContentCopy } from "@mui/icons-material";
import HandleInterviewLink, { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";

const PositionTrackerListing = () => {
  const [selectedStatus, setSelectedStatus] = useState<any>();
  // const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const [exportAnchorEl, setExportAnchorEl] = useState(null);
  const [selectFilterStatus, setSelectedFilterStatus] = useState<string | any>(
    "Applied"
  );
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [offset, setOffset] = useState<number>(0);
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [isApplyDialogOpen, setIsApplyDialogOpen] = useState(false);
  const [sortOrder, setSortOrder] = useState<any>("asc");
  const [sortBy, setSortBy] = useState("name");
  const [appliedData, setAppliedData] = useState<any>([]);
  const [notAppliedData, setNotAppliedData] = useState<any>([]);
  const [notEligibleData, setNotEligibleData] = useState<any>([]);
  const state = useLocation();
  const userData = getUser();
  const handleStatusFilterChange = (event: any, newValue: any) => {
    setSelectedStatus(newValue);
  };
  const handleMenuClose = (setAnchor: any) => () => {
    setAnchor(null);
  };
  const handleMenuOpen = (setAnchor: any) => (event: any) => {
    setAnchor(event.currentTarget);
  };
  const handleStatusFilterActionChange = (action: string) => {
    setOffset(0);
    setSortBy("name");
    setSortOrder("asc");
    setPage(0);
    setSelectedFilterStatus(action);
    switch (action) {
      case "Applied": {
        setNotAppliedData([]);
        setNotEligibleData([]);
        break;
      }
      case "Not Eligible": {
        setAppliedData([]);
        setNotAppliedData([]);
        break;
      }
      case "Not Applied": {
        setAppliedData([]);
        setNotEligibleData([]);
        break;
      }
    }
  };
  const handleApplyClose = () => {
    setIsApplyDialogOpen(false);
    getPositionData();
    setNotAppliedData([]);
  };
  const handleApplyClick = async (id: number) => {
    try {
      let response = await API.post("/positions/apply-positions", {
        positionIds: [id],
      });
      if (response?.status == 200 || response?.statusText == "OK") {
        setIsApplyDialogOpen(true);
      }
    } catch (error) {
      // Failed to fetch position tracker data
    } finally {
    }
  };
  const handlePageChange = (event: any, newPage: any) => {
    setPage(newPage);
    setOffset(newPage * rowsPerPage);
  };
  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSort = (property: any) => {
    const isAsc = sortOrder === "asc";
    setSortOrder(isAsc ? "desc" : "asc");
    setSortBy(sortOrder === "asc" ? `-${property}` : property);
  };

  const positionColumnsHeader = {
    Applied: [
      "Position",
      "Application Date",
      "Status",
      "Notes",
      "Level",
      "Interview Link",
    ],
    NotApplied: ["Position", "Status", "Level", "Action"],
  };

  const getPositionData = async () => {
    setDataLoading(true);
    try {
      if (selectFilterStatus == "Applied") {
        const respose = await API.get(
          `/items/candidate_applications/?fields=*,position_id.name,position_id.level,scheduled_applications.webex_link&filter[status]=published&meta=*&sort=${
            sortBy == "-name" ? "-position_id.name" : "position_id.name"
          }&offset=${offset}&limit=${rowsPerPage}&filter[candidate_id]=${
            userData?.user?.id
          }`
        );
        // console.log("response", respose);
        setAppliedData(respose?.data?.data);
        setTotalRecords(respose?.data?.meta?.filter_count);
      } else if (selectFilterStatus == "Not Applied") {
        const response = await API.post(
          "/positions/get-not-applied-positions",
          {
            offset: offset,
            limit: rowsPerPage,
            sort: sortBy === "-name" ? "name desc" : "name asc",
          }
        );
        // console.log(response);
        setNotAppliedData(response?.data?.data);
        setTotalRecords(response?.data?.meta?.filter_count);
      } else {
        const response = await API.post("/positions/get-positions", {
          isEligible: false,
          offset: offset,
          limit: rowsPerPage,
          sort: sortBy,
        });
        setNotEligibleData(response?.data?.data);
        setTotalRecords(response?.data?.meta?.filter_count);
      }
    } catch (error) {
      // Failed to load position tracker data
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (state?.state?.view) {
      setSelectedFilterStatus(state?.state?.view);
    }
  }, [state?.state?.view]);

  useEffect(() => {
    getPositionData();
  }, [selectFilterStatus, offset, rowsPerPage, sortBy]);

  const navigate = useNavigate();

  return (
    <PageWrapper>
      <PageHeader title="Position Tracker"></PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
              <Typography variant="body1">Candidate Name</Typography>
              <Typography variant="subtitle2">
                {userData?.user?.fullname}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
              <Typography variant="body1">Mobile Number</Typography>
              <Typography variant="subtitle2">
                {userData?.user?.mobile}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
              <Typography variant="body1">Email Address</Typography>
              <Typography variant="subtitle2">
                {userData?.user?.email}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 3 }} marginBottom={4}>
              <Typography variant="body1">INFRACON Status</Typography>
              <Typography variant="subtitle2">
                {userData?.user?.is_infracon_verified
                  ? "Verified"
                  : "Not Verified"}
              </Typography>
            </Grid2>
          </Grid2>

          <Box marginTop={2}>
            <ViewTableWrapper>
              <ViewTableWrapper.Header title="Total Position">
                <Box display="flex" justifyContent={"center"} gap={2}>
                  {/* This two fields we will use in future */}
                  {/* {selectFilterStatus === "Applied" &&
                   <FormControl
                    sx={{ width: "150px" }}
                    size="small"
                    className="status-dropdown"
                  >
                    <Autocomplete
                      size="small"
                      disablePortal
                      options={SCHEDULE_STATUS || []}
                      getOptionLabel={(option) => option?.title || ""}
                      value={selectedStatus}
                      onChange={handleStatusFilterChange}
                      componentsProps={{
                        clearIndicator: { disableRipple: true },
                        popupIndicator: { disableRipple: true },
                      }}
                      sx={{
                        width: 150,

                        "& .MuiAutocomplete-inputRoot": {
                          backgroundColor: "white",
                          borderRadius: "8px",
                        },
                        "&:hover:": {
                          border: "transparent",
                        },
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Status"
                          variant="outlined"
                          placeholder="Status"
                          InputProps={{
                            ...params.InputProps,
                            disableUnderline: true,
                            sx: {
                              color: "grey !important",
                              backgroundColor: "red",
                              padding: "6px 12px",
                              height: "45px",
                              "&:hover": {
                                borderColor: "#fff",
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </FormControl>} */}
                  <Box
                    display="flex"
                    justifyContent={"between"}
                    gap={1}
                    sx={{
                      border: "0.5px solid #6AAEF1",
                      borderRadius: "8px",
                      padding: "5px",
                    }}
                  >
                    {["Applied", "Not Applied", "Not Eligible"].map(
                      (action: string) => (
                        <MatButton
                          key={action}
                          onClick={() => handleStatusFilterActionChange(action)}
                          className="position-action-btn"
                          sx={{
                            backgroundColor:
                              selectFilterStatus === action
                                ? "#D3E9FF"
                                : "white",
                          }}
                        >
                          {action}
                        </MatButton>
                      )
                    )}
                  </Box>

                  {/* <MatButton
                    variant="outlined"
                    color="inherit"
                    startIcon={<img src={ExportIcon} alt="export" />}
                    endIcon={
                      <KeyboardArrowDownRoundedIcon
                        style={{ color: "#8F8F8F" }}
                      />
                    }
                    onClick={handleMenuOpen(setExportAnchorEl)}
                    sx={{
                      backgroundColor: "#fff",
                      border: "1px solid #E6E7E9",
                    }}
                  >
                    Export As
                  </MatButton> */}
                  <Menu
                    sx={{
                      maxWidth: "100% !important",
                    }}
                    anchorEl={exportAnchorEl}
                    open={Boolean(exportAnchorEl)}
                    onClose={handleMenuClose(setExportAnchorEl)}
                  >
                    <MenuItem onClick={handleMenuClose(setExportAnchorEl)}>
                      PDF
                    </MenuItem>
                    <MenuItem onClick={handleMenuClose(setExportAnchorEl)}>
                      Excel
                    </MenuItem>
                  </Menu>
                </Box>
              </ViewTableWrapper.Header>
              <Divider />
              <ViewTableWrapper.Content>
                <Box
                  marginTop={1}
                  sx={{ overflowY: "auto", flex: "1 1 auto", display: "grid" }}
                >
                  <TableContainer
                    className="secondary__table"
                    sx={{
                      maxHeight: 360,
                      overflowX: 'unset'
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          {selectFilterStatus === "Applied"
                            ? positionColumnsHeader.Applied.map(
                                (value: string, index: number) => {
                                  return value === "Position" ? (
                                    <TableCell key={index} >
                                      <Box  onClick={() => handleSort("name")} sx={{cursor:"pointer"}}>
                                      {value}
                                      <TableSortLabel
                                        sx={{ width: "80px !important" }}
                                        active={sortBy === "name" || sortBy === "-name"}
                                        direction={sortOrder}
                                      ></TableSortLabel>
                                      </Box>
                                    </TableCell>
                                  ) : (
                                    <TableCell
                                      key={index}
                                      sx={{
                                        textAlign:
                                          value === "Level" ||
                                          value === "Status"
                                            ? "center"
                                            : "left",
                                        width:
                                          value === "Level" ||
                                          value === "Interview Link"
                                            ? "10% !important"
                                            : value === "Notes"
                                            ? "50% !important"
                                            : undefined,
                                        minWidth:
                                          value === "Level" ||
                                          value === "Interview Link"
                                            ? "7rem !important"
                                            : value === "Notes"
                                            ? "20rem !important"
                                            : undefined,
                                      }}
                                    >
                                      {value}
                                    </TableCell>
                                  );
                                }
                              )
                            : positionColumnsHeader.NotApplied.map((value) => {
                                return value === "Position" ? (
                                  <TableCell key={value}>
                                    <Box  onClick={() => handleSort("name")} sx={{cursor:'pointer'}}>
                                    {value}
                                    <TableSortLabel
                                      active={sortBy === "name"||sortBy === "-name"}
                                      direction={sortOrder}
                                      onClick={() => handleSort("name")}
                                    ></TableSortLabel>
                                  </Box>
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    align={
                                      value === "Level" || value === "Status"
                                        ? "center"
                                        : "center"
                                    }
                                  >
                                    {value}
                                  </TableCell>
                                );
                              })}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {selectFilterStatus === "Applied" ? (
                          dataLoading ? (
                            <TableCell colSpan={6} align="center">
                              <Box sx={{ height: "200px" }}>
                                <DataLoader />{" "}
                              </Box>
                            </TableCell>
                          ) : appliedData.length > 0 ? (
                            appliedData?.map((value: any) => {
                              return (
                                <TableRow>
                                  <TableCell>
                                    {value?.position_id?.name || "NA"}
                                  </TableCell>
                                  <TableCell>
                                    {handleDate(value?.application_date)}
                                  </TableCell>
                                  <TableCell align="center">
                                    {value?.application_display_status ==
                                    "Applied" ? (
                                      <SlotStatus type="applied" />
                                    ) : value?.application_display_status ==
                                      "Empanelled" ? (
                                      <SlotStatus type="empaneled" />
                                    ) : value?.application_display_status ==
                                      "Not-Empanelled" ? (
                                      <SlotStatus type="notempaneled" />
                                    ) : value?.application_display_status ==
                                      "Interview Scheduled" ? (
                                      <SlotStatus type="interviewscheduled" />
                                    ) : value?.application_display_status ==
                                        "Interview Rescheduled" ||
                                      value?.application_display_status ==
                                        "Interview Re-scheduled" ? (
                                      <SlotStatus type="interviewrescheduled" />
                                    ) : value?.application_display_status ==
                                      "Rescheduling in Progress" ? (
                                      <SlotStatus type="reschedulinginprogress" />
                                    ) : (
                                      value?.application_display_status || "NA"
                                    )}
                                  </TableCell>
                                  <TableCell sx={{ maxWidth: "250px" }}>
                                    {value?.additional_notes || "NA"}
                                  </TableCell>
                                  <TableCell align="center">
                                    {value?.position_id?.level || "NA"}
                                  </TableCell>
                                  <TableCell>
                                    {
                                      <HandleInterviewLink
                                        link={
                                          value?.scheduled_applications?.[0]
                                            ?.webex_link
                                        }
                                      />
                                    }
                                  </TableCell>
                                  {/* <TableCell>
                                  {value?.interview_link ? (
                                    <MatButton
                                      component="a"
                                      href={value.interview_link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      sx={{
                                        padding: 0,
                                        color: "blue",
                                        textTransform: "none",
                                        textDecoration: "none",
                                        "&:hover": {
                                          textDecoration: "underline",
                                        },
                                      }}
                                    >
                                      {value.interview_link}
                                    </MatButton>
                                  ) : (
                                    <MatButton>
                                    NA
                                    </MatButton>
                                  )} 
                                </TableCell>*/}
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableCell colSpan={6} align="center">
                              <Box
                                sx={{
                                  maxHeight: "300px",
                                }}
                              >
                                <DataNotFound />
                              </Box>
                            </TableCell>
                          )
                        ) : selectFilterStatus === "Not Applied" ? (
                          dataLoading ? (
                            <TableCell colSpan={4} align="center">
                              <Box sx={{ height: "200px" }}>
                                <DataLoader />
                              </Box>
                            </TableCell>
                          ) : notAppliedData.length > 0 ? (
                            notAppliedData.map((value: any) => {
                              return (
                                <TableRow>
                                  <TableCell>{value?.name}</TableCell>
                                  <TableCell align="center">
                                    <SlotStatus
                                      type={
                                        value?.is_eligible == true
                                          ? "eligible"
                                          : "noteligible"
                                      }
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    {value?.level}
                                  </TableCell>
                                  <TableCell align="center">
                                    <MatButton
                                      sx={{ padding: "0" }}
                                      onClick={() => {
                                        handleApplyClick(value?.id);
                                      }}
                                    >
                                      Apply
                                    </MatButton>
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableCell colSpan={4} align="center">
                              <Box
                                sx={{
                                  maxHeight: "300px",
                                }}
                              >
                                <DataNotFound />
                              </Box>
                            </TableCell>
                          )
                        ) : dataLoading ? (
                          <TableCell colSpan={4} align="center">
                            <Box sx={{ height: "200px" }}>
                              <DataLoader />
                            </Box>
                          </TableCell>
                        ) : notEligibleData.length > 0 ? (
                          notEligibleData.map((value: any) => {
                            return (
                              <TableRow>
                                <TableCell>{value?.name}</TableCell>
                                <TableCell align="center">
                                  <SlotStatus
                                    type={
                                      value?.eligible_positions[0]
                                        ?.is_eligible == false
                                        ? "noteligible"
                                        : "eligible"
                                    }
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  {value?.level}
                                </TableCell>
                                <TableCell align="center">
                                  <MatButton
                                    onClick={() => {
                                      if (
                                        value?.eligible_positions[0]
                                          ?.candidate_queries?.length > 0
                                      ) {
                                        navigate("/admin/query-tracker", {
                                          state: {
                                            data: value,
                                          },
                                        });
                                      } else {
                                        navigate("raise-query", {
                                          state: {
                                            view: "Not Eligible",
                                            data: value,
                                          },
                                        });
                                      }
                                    }}
                                  >
                                    {value?.eligible_positions[0]
                                      ?.candidate_queries?.length > 0
                                      ? "View Query"
                                      : "Raise Query"}
                                  </MatButton>
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableCell colSpan={4} align="center">
                            <Box
                              sx={{
                                maxHeight: "300px",
                              }}
                            >
                              <DataNotFound />
                            </Box>
                          </TableCell>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </ViewTableWrapper.Content>
            </ViewTableWrapper>
            {(appliedData?.length > 0 ||
              notEligibleData?.length > 0 ||
              notAppliedData?.length > 0) && (
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={totalRecords}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            )}
          </Box>
          <SuccessDialog
            open={isApplyDialogOpen}
            onClose={handleApplyClose}
            onConfirm={handleApplyClose}
            summary={
              <span>
                You have Successfully
                <br />
                Applied for the Selected Positions
              </span>
            }
          />
        </CardContent>
      </Card>
    </PageWrapper>
  );
};

export default PositionTrackerListing;
